const placeholderText = 'Search your published wires or wires which mention you';
const recentCareerTip = 'Previous role information will not be visible on your profile unless all fields are complete.';
const featuredWiresTip = 'Mentions that don’t have a primary image will not appear in featured wire search.';
const mentionMissingImageTip = 'The wire author has removed the primary image so it can no longer be featured.';

export {
// eslint-disable-next-line import/prefer-default-export
  placeholderText,
  recentCareerTip,
  featuredWiresTip,
  mentionMissingImageTip,
};
